var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEyeOpenHollowEyeball = function SvgEyeOpenHollowEyeball(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 40 40"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.2,
    d: "M36.666 20C33.755 25.96 26.462 30.833 20 30.833S6.244 25.961 3.333 20M36.666 20C33.755 14.04 26.463 9.167 20 9.167S6.244 14.039 3.333 20",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.2,
    d: "M25 20a5 5 0 1 1-10 0 5 5 0 0 1 10 0"
  })));
};
export default SvgEyeOpenHollowEyeball;